import { selectBillingServiceTypesState } from '../index';
import { createSelector } from '@ngrx/store';
import { BillingServiceTypesState } from '../reducers/billing-service-types.reducer';

export const selectBillingDateFormats = createSelector(
  selectBillingServiceTypesState,
  (state: BillingServiceTypesState) => state && state.dateFormats
);
export const selectBillingServiceTypes = createSelector(
  selectBillingServiceTypesState,
  (state: BillingServiceTypesState) => state && state.serviceTypes
);
export const selectBillingTransactionDateStrategies = createSelector(
  selectBillingServiceTypesState,
  (state: BillingServiceTypesState) => state && state.transactionDateStrategies
);
export const selectBillingServiceTypesLoading = createSelector(
  selectBillingServiceTypesState,
  (state: BillingServiceTypesState) => state && state.loading
);
export const selectBillingServiceTypesError = createSelector(
  selectBillingServiceTypesState,
  (state: BillingServiceTypesState) => state && state.error
);
